import React from "react";
import { Skeleton } from "antd";

//styles
import styles from "@/assets/styles/components/location-card.module.scss";

function LocationCardPreloader() {

  return (
    <div className={styles["locl-location-card-preloader"]} data-testid="locl-location-card-preloader">
      <Skeleton.Input className={styles["locl-location-card-preloader__image"]} active block/>
      <Skeleton.Input className={styles["locl-location-card-preloader__title"]} active block/>
      <Skeleton.Input className={styles["locl-location-card-preloader__location-info"]} active block/>
      <Skeleton.Input className={styles["locl-location-card-preloader__drawer-button"]} active block/>
    </div>
  );
}

export default LocationCardPreloader;
